import _ from 'lodash';
import { bindCallbacks, statusText } from 'scripts/infrastructure/backends/fake_backend_http/lib/common';
import qconsole from 'scripts/lib/qconsole';

/**
 * This service supports the graphQL-based route `/api/v1/orgs/:orgId/external-data/graphql/ui-template-data`
 */
export default class ExternalDataObjectService {
  constructor(database, pubsub) {
    this._pubsub = pubsub;
    this.getDatabase = database;
  }

  getGraphQLData(payload, callback, path, params) {
    const { orgId } = params || {};
    const { namespace, configurationId, uiTemplateId, queryField, forceDataRefresh } = payload || {};

    if (!orgId) {
      return callback(Error(statusText(404)), {
        status: 404,
        statusText: statusText(404),
      });
    }

    if (!configurationId || !uiTemplateId || !queryField || !namespace) {
      return callback(Error(statusText(400)), {
        status: 400,
        statusText: statusText(400),
      });
    }

    if (forceDataRefresh) {
      qconsole.log('ExternalDataObjectService.findGraphQL: data refresh requested');
    }

    let database;
    try {
      database = this.getDatabase(orgId);
      if (!database) {
        return callback(Error(statusText(500)), { status: 500, statusText: `No database for org ${orgId}` });
      }
    } catch (err) {
      return callback(Error(statusText(500)), {
        status: 500,
        statusText: `Unable to get database for org ${orgId}: ${err.message}`,
      });
    }

    const dataObject = _.get(database, `externalAppData.graphQL.${namespace}`);
    setTimeout(() => {
      const items = makeArray(dataObject);
      callback(null, {
        status: 200,
        statusText: statusText(200),
        response: {
          data: items,
          errors: dataObject ? null : [{ code: 'NOT_EXIST' }],
        },
      });
    }, Math.ceil(5000 * Math.random()));
  }

  getRoutes() {
    return bindCallbacks(
      {
        '/api/v1/orgs/:orgId/external-data/graphql/ui-template-data': {
          POST: this.getGraphQLData,
        },
      },
      this
    );
  }
}

function makeArray(value) {
  if (!value) return [];
  return _.isArray(value) ? value : [value];
}
